import { FC } from 'react';
import MobileAppsDetails from 'src/MobileApps/components/Details';
import MobileAppsCTA from 'src/MobileApps/components/CTA';
import MobileAppsHero from 'src/MobileApps/components/Hero';

const MobileAppsRoot: FC = () => (
  <main>
    <MobileAppsHero />
    <MobileAppsDetails />
    <MobileAppsCTA />
  </main>
);

export default MobileAppsRoot;
